import type {
	BasicCustomMailItemSendOptionalInput,
	BasicCustomMailItemSendRequiredInput,
} from "@/lib/gql/__generated__/graphql";

type Props = {
	label: string;
	basicCustomMailSetting: BasicCustomMailItemSendRequiredInput | BasicCustomMailItemSendOptionalInput | undefined;
};

export const QuestionEmailTemplateItemWithText = ({ label, basicCustomMailSetting }: Props) => {
	const isShowText = !!basicCustomMailSetting?.text;

	return (
		<>
			<div className="space-y-3">
				<div className="flex items-end justify-between">
					<p className="text-sm font-semibold">{label}</p>
				</div>
				<div className="bg-gray-50 rounded-md p-3">
					{isShowText ? (
						<div className="text-gray-800 whitespace-pre-wrap text-sm">{basicCustomMailSetting.text}</div>
					) : (
						<div className="text-gray-800 whitespace-pre-wrap text-sm font-semibold">
							基本メール設定は未設定です
						</div>
					)}
				</div>
			</div>
		</>
	);
};

QuestionEmailTemplateItemWithText.displayName = "QuestionEmailTemplateItemWithText";
